import React from 'react';
import logo from '../images/NOS-Logo-Horizontal-Color-Black.svg';
import adex from '../images/adex.png';
import bt from '../images/blatand.png';
import artbygg from '../images/artbygg-black.png';
import nm1 from '../images/låda-grey-orange-2.png';
import relco from '../images/Logo - horizontal.svg';
import icon from '../images/NOS-Logo-Brandmark-Color-Medium.png';
import srm from '../images/srm_logga_utan_mobnummer-cropped-1.png';
import khel from '../images/Horizontal 500.png';
import tjust from '../images/tjust.png';
import creativereklam from '../images/creative_reklam_logo.png';
import sormlands from '../images/sormlands_varmepumpar_logo.png';
import ridderborgs from '../images/ridderborgs.png';

function Home() {
  return (
    <>
    <div className='navbar'>
      <div className='logo-cont'>
          <a href="/#home"><img src={logo} href='#home' className='logo-small' alt=''></img></a>
      </div>
        <div className='navlinks'>
          <a href='#products'>Products</a>
          <a href='#about-us'>About us</a>
          <a href='#contact'>Get in touch</a>
        </div>
        <div className='btn-cont'>
          <a className='btn' href="https://www.relco.se">Discover Relco</a>
        </div>
    </div>
    <div className='sec' id='home'>
        <div className='cont'>
            <h1 className='title'>Built to help businesses grow.</h1>
            <div className='navmenu'>
              <img src={icon} alt=''></img>
            </div>
        </div>
    </div>
    <div className='carousel'>
        <div className='group'>
            <img className='logo' src={adex} alt='adex'></img>
            <img className='logo' src={bt} alt='blåtand'></img>
            <img className='logo' src={artbygg} alt='art bygg'></img>
            <img className='logo' src={srm} alt='srm'></img>
            <img className='logo' src={khel} alt='khel'></img>
            <img className='logo' src={creativereklam} alt='creativereklam'></img>
            <img className='logo' src={tjust} alt='tjust'></img>
            <img className='logo' src={sormlands} alt='sormlands'></img>
            <img className='logo' src={ridderborgs} alt='ridderborgs'></img>
        </div>
        <div aria-hidden className='group'>
            <img className='logo' src={adex} alt='adex'></img>
            <img className='logo' src={bt} alt='blåtand'></img>
            <img className='logo' src={artbygg} alt='art bygg'></img>
            <img className='logo' src={srm} alt='srm'></img>
            <img className='logo' src={khel} alt='khel'></img>
            <img className='logo' src={creativereklam} alt='creativereklam'></img>
            <img className='logo' src={tjust} alt='tjust'></img>
            <img className='logo' src={sormlands} alt='sormlands'></img>
            <img className='logo' src={ridderborgs} alt='ridderborgs'></img>
        </div>
        <div aria-hidden className='group'>
            <img className='logo' src={adex} alt='adex'></img>
            <img className='logo' src={bt} alt='blåtand'></img>
            <img className='logo' src={artbygg} alt='art bygg'></img>
            <img className='logo' src={srm} alt='srm'></img>
            <img className='logo' src={khel} alt='khel'></img>
            <img className='logo' src={creativereklam} alt='creativereklam'></img>
            <img className='logo' src={tjust} alt='tjust'></img>
            <img className='logo' src={sormlands} alt='sormlands'></img>
            <img className='logo' src={ridderborgs} alt='ridderborgs'></img>
        </div>
    </div>
    <div className='sec' id='products'>
        <h1 className='heading'>Our products</h1>
        <div className='box-cont'>
          <div className='box'>
            <div className='left'>
              <h3 className='subtitle'>Relco</h3>
              <h2 className='box-title'>Feedback automated</h2>
              <p>
                Lift your business - without lifting a finger. Just connect your ERP system and continue doing what you do best. Our AI-powered system will do the rest.
              </p>
              <a className='btn' href='https://www.relco.se'>Learn more</a>
            </div>
            <div className='right center'>
              <img id='relco-logo' src={relco} alt='relco logo' style={{width: "200px", padding: "20px 0"}}></img>
            </div>
          </div>
          <div className='box'>
            <div className='left'>
              <h3 className='subtitle'>NOS Machine 1</h3>
              <h2 className='box-title'>Optical berry analysis</h2>
              <p>
              NOS Machine 1 enables powerful analysis of berry content in seconds. Simply place a box of berries in the machine and initiate the analysis from the touchscreen. A photo will be taken under controlled lighting conditions and will automatically be sent to the NOS Platform for an instant analysis of the content. See the results directly on the touchscreen or follow them up on the Web App, anytime and anywhere you want.
              </p>
            </div>
            <div className='right center'>
              <img id='nm1' src={nm1} alt=''></img>
            </div>
          </div>
        </div>
    </div>
    <div className='sec' id='about-us'>
        <div className='box blackbox'>
          <div className='left'>
            <h3 className='subtitle'>About us</h3>
            <h2 className='box-title'>Helping businesses grow</h2>
            <p>
              NOS Technology AB was founded to help other businesses make more money.

              With a background in design, product development, and technology, we use digital tools to achieve this. AI is central to our products and our way of working.
            </p>
          </div>
          <div className='right black'>
            <h2>Why Relco</h2>
            <ul>
              <li>Instant results on Google Search</li>
              <li>Builds trust and credibility</li>
              <li>Only good reviews - without losing out on valuable feedback</li>
              <li>Personal and responsive</li>
              <li>Reads your invoices automatically - no manual work</li>
            </ul>
            <a className='btn btn-white' href='https://www.relco.se' style={{marginTop: '20px'}}>Learn more</a>
          </div>
        </div>
    </div>
    <div className='sec' id='contact'>
        <div className='box'>
          <div className='left'>
            <h3 className='subtitle'>Contact</h3>
            <h2 className='box-title'>Get in touch</h2>
            <h4>Karl Hagner, CEO</h4>
            <div className='colinks'>
              <a href='tel:+46730206572'>073-020 65 72</a>
              <a href='mailto:karl@nostechnology.com'>karl@nostechnology.com</a>
            </div>
            <h4>Olof Helleblad Johnson, CPO</h4>
            <div className='colinks'>
              <a href='tel:+46706310282'>070-631 02 82</a>
              <a href='mailto:karl@nostechnology.com'>olof@nostechnology.com</a>
            </div>
          </div>
          <div className='right'>
            <h2>Company</h2>
            <div className='btns'>
              <a className='btn' href='mailto:info@nostechnology.com'>info@nostechnology.com</a>
              <a className='btn' href='mailto:support@nostechnology.com'>support@nostechnology.com</a>
              <a className='btn' href='mailto:info@relco.se'>info@relco.se</a>
            </div>
          </div>
        </div>
    </div>
    <div className='sec'>
      NOS Technology AB {new Date().getFullYear()}
    </div>
    </>
  )
}

export default Home